import base from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';

// Funnel / pyramid plot a single metric broken down by a dimension, with each
// member as a decreasing (funnel) or increasing (pyramid) band. Reuses the
// single-metric name/value breakdown. Requires the funnel module (registered in
// Chart.tsx). `type` is 'funnel' or 'pyramid'.
const funnel = ({
  formatMetric,
  title,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  fontSize,
  type,
}) => ({
  ...base(formatMetric),
  chart: {
    ...base(formatMetric).chart,
    type: type === 'pyramid' ? 'pyramid' : 'funnel',
    marginRight: 100,
  },
  title: {
    ...base(formatMetric).title,
    text: title,
  },
  legend: {
    ...base(formatMetric).legend,
    enabled: false,
  },
  plotOptions: {
    series: {
      borderWidth: 0,
      center: ['40%', '50%'],
      // Neck (the straight lower section) only applies to funnels; a pyramid
      // must taper all the way to a point, so zero it out.
      neckWidth: type === 'pyramid' ? '0%' : '30%',
      neckHeight: type === 'pyramid' ? '0%' : '25%',
      width: '80%',
      dataLabels: {
        enabled: true,
        style: {
          color: 'var(--color-text-primary)',
          textOutline: 'none',
          fontWeight: 'normal',
          fontSize,
        },
        formatter: function () {
          const value = formatMetric({
            metricId: this.series.userOptions.metricId,
            value: this.y,
          });
          return `<b>${this.point.name}</b> (${value})`;
        },
        softConnector: true,
      },
      point: {
        events: {
          click: function () {
            if (openMenu) {
              const { metricIds } = this.series.userOptions;
              openMenu(
                metricIds,
                buildDrillDown(groupField, fieldType, this.name, chartDef),
              );
            } else {
              const { onDrillDown } = this.series.userOptions;
              if (!onDrillDown) {
                alert('Coming soon...');
                return;
              }
              onDrillDown(this.name);
            }
          },
        },
      },
    },
  },
  tooltip: {
    ...base(formatMetric).tooltip,
    shared: false,
    useHTML: true,
    pointFormatter: function () {
      const value = formatMetric({
        metricId: this.series.userOptions.metricId,
        value: this.y,
      });
      // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables.
      return `<span style="color:${this.color}">● </span><span style="color: var(--color-text-muted);">${this.name}: </span><b>${value}</b>`;
    },
  },
});

export default funnel;
